import { Skeleton, TableCell, TableRow, cn } from '@parcel/ui';

/** Stable keys for placeholder rows, which have no identity of their own. */
function placeholderKeys(prefix: string, count: number): string[] {
  return Array.from({ length: count }, (_, index) => `${prefix}-${index}`);
}

/** Placeholder rows for a settings table while it loads; never the word "Loading". */
export function TableSkeletonRows({ columns, rows = 4 }: { columns: number; rows?: number }) {
  const columnKeys = placeholderKeys('column', columns);
  return (
    <>
      {placeholderKeys('row', rows).map((rowKey) => (
        <TableRow key={rowKey} className="hover:bg-transparent" data-testid="table-skeleton-row">
          {columnKeys.map((columnKey) => (
            <TableCell key={columnKey} className="py-3">
              <Skeleton
                className={cn('h-4', columnKey === columnKeys[0] ? 'w-40 max-w-full' : 'w-16')}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}

/** Placeholder rows for a divided settings list: a label and a trailing control. */
export function ListSkeleton({ rows = 3, className }: { rows?: number; className?: string }) {
  return (
    <div className={cn('divide-y', className)} data-testid="list-skeleton">
      {placeholderKeys('item', rows).map((key) => (
        <div key={key} className="flex items-center justify-between gap-4 p-4">
          <div className="min-w-0 flex-1 space-y-2">
            <Skeleton className="h-4 w-48 max-w-full" />
            <Skeleton className="h-3 w-32 max-w-full" />
          </div>
          <Skeleton className="h-8 w-20" />
        </div>
      ))}
    </div>
  );
}
